import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import locales from './locales'

i18n.use(initReactI18next).init({
  debug: process.env.NODE_ENV === 'development',
  interpolation: {
    escapeValue: false,
  },
  lng: 'en',
  fallbackLng: 'en',
  resources: locales,
})

export default i18n
